// models/guest.js

export const createGuest = () => ({
  name: "",
  isAttendingCeremony: false,
  isAttendingReception: false,
  mealPreference: "",
  dietaryRestrictions: "",
});
